import '../music.css';
import { Layout,ConfigProvider,Table,Modal,Menu,Input, Space, AutoComplete,notification, Select,Button } from 'antd';
import React, { Component } from "react";
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, UserOutlined,EditOutlined,MailOutlined, PhoneOutlined, GlobalOutlined, EnvironmentOutlined, IdcardOutlined,BarChartOutlined } from '@ant-design/icons';
import axios from "axios";
import countries from '../static/json/countries.json'
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays' 
import {getAuthors,getAuthorsStr, getCountryName,getCountryCode, IP  } from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from "../components/AdminMenu"

class ConcList extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;
    this.state={
      concs:[],
      authors:[],
      edit:false,
      countryName:'',
      countrychanged:'',
      plays_report:[],
      filteredInfo:[],
      isBusy:true
    }
  }
  async componentWillMount() {
    //Plays
    const response_plays = await fetch(IP + 'api/musica/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    
    var data_play = []
    const json_plays = await response_plays.json();
    if(json_plays['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    const Moment = require('moment');
    for(var i in json_plays){
      var item = json_plays[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      const year = date.split('-')[2]
      var authorStr = getAuthorsStr(item.conc).join(", ")
      data_play.push(
          { 
              id : i,
              title : item.titulo,
              author: author ,
              authorStr:authorStr,
              date:date,
              pseudo: item.pseudonimo,
              code:year+'_'+item.id,
              conc:item.conc,
              pdf:item.pdf,
              edit:''
          });
    };

    //Conc
    var data = []
    this.names = new Set();
    this.emails = new Set();
    this.countries = new Set();
    const json_conc =[].concat.apply([],json_plays.map(play=> {return play.conc})) ;
    for(var i in json_conc){
      var item = json_conc[i];
      this.names.add(item.nombre_completo)
      this.emails.add(item.email)
      this.countries.add(item.pais)
      data.push(
          { 
              id : item.id,
              name : item.nombre_completo,
              country: item.pais,
              countryName: getCountryName(item.pais),
              ficha: item.ficha,
              phone: item.telefono,
              address: item.direcc_personal,
              email: item.email,
          });
    };

    this.names = [...this.names].map((v)=>{
      return {value:v}
    })
    this.emails =[...this.emails].map((v)=>{
      return {value:v}
    })
    this.countries = [...this.countries].map((v)=>{
      return {value:getCountryName(v)}
    })
    this.setState({ concs: data, plays_report:data_play, filteredInfo: data, isBusy:false });
  }

  onChangeSelect(value){
    this.setState({countrychanged:value})
  }

  handleTableChange = (pagination, filters, sorter, extra) => {
    this.setState({
      filteredInfo: extra['currentDataSource']
    });
  }

  getAutocomplete = (dataIndex) =>{
    if(dataIndex == "code"){
      return this.codes
    }
    else if (dataIndex == "name" ) {
        return this.names
    } 
    else if (dataIndex== "email"){
      return this.emails
    }
    else{
      return this.countries
    }
  }
  onClickArticle = record  => {
        this.setState({showArticle:true,record:record});
  };

  async onClickSave(){

    var options = {
       method: "patch",
       credentials: "same-origin",
       headers: {
         "Authorization": localStorage.getItem("Authorization") ,
         "Accept": "application/json",
         "Content-Type": "application/json"},
      
     }
    var concChanged={
      nombre_completo: document.getElementById("nameInput").value,
      email: document.getElementById("emailInput").value,
      telefono: document.getElementById("phoneInput").value,
      direcc_personal:document.getElementById("addressInput").value,
      ficha:document.getElementById("fichaInput").value,
      pais:this.state.countrychanged?getCountryCode(this.state.countrychanged):this.state.record.country,
    }
     
     await axios.patch(IP + `api/concursantes/${this.state.record.id}/`, concChanged, options)
     .then(
       (response) => {
         if(response.status === 200)
            window.location.reload()
          else{
            notification.error({
            message:'Error',
            description:'Hubo un error, por favor revise los datos',
          });
          }
       },
       (error) => {
        notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
        })
       }
     ).catch((err) => console.log(err))
   }

  onClickEditPlay= record  => {
        this.setState({edit:true,record:record,});
  };
  hideModal = () => {
        this.setState({
          showArticle: false,
          record: null,
        });
  };

  hideEdit = () => {
    this.setState({
      edit: false,
      record: null,
    });
};
getColumnSearchProps = (dataIndex,name) => dataIndex!='edit' && ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => ( dataIndex!='edit' &&
        <div style={{ padding: 8 }}>
          <AutoComplete 
          style={{ width: 188, marginBottom: 8, display: 'block' }}
          options={this.getAutocomplete(dataIndex)}
          filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
          onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
          value={selectedKeys[0]}

          >
            <Input className='music-input'
              ref={node => {
              this.searchInput = node;
            }}
            placeholder={`Buscar ${name}`}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          />
          </AutoComplete>
          <Space>
            <Button
              type="primary"
              onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Buscar
            </Button>
            <Button onClick={() => this.handleReset(clearFilters)} size="small" type="reset" style={{ width: 90 }}>
              Resetear
            </Button>
  
          </Space>
        </div>
      ),
      filterIcon: filtered =>dataIndex!='edit' && <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
          : '',
      onFilterDropdownVisibleChange: visible => {
        if (visible && dataIndex!= 'edit') {
          setTimeout(() => this.searchInput.select(), 100);
        }
      },
      render: (text,record,index) =>
        this.state.searchedColumn === dataIndex ? (
          <div style={{fontSize:'large' }}>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[this.state.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
          </div>
        ) : (
          <div  style={{fontSize:'large' }}>
          {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>)||
          <a onClick = {()=>this.onClickArticle(record)} >  {text} </a>}
          </div>
        ),
    });
    
    handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      this.setState({
        searchText: selectedKeys[0],
        searchedColumn: dataIndex,
      });
    };
    
    handleReset = clearFilters => {
      clearFilters();
      this.setState({ searchText: '' });
    };

  render() {
    const downloadPlayReport =()=> generatePDFPlay(this.state.plays_report,"save")
    const readPlayReport =()=> generatePDFPlay(this.state.plays_report,"read")
    
    const downloadCurrentReport =()=> generatePDFConc(this.state.filteredInfo,"save")
    const readCurrentReport =()=> generatePDFConc(this.state.filteredInfo,"read")
    
    const downloadConcReport =()=> generatePDFConc(this.state.concs,"save")
    const readConcReport =()=> generatePDFConc(this.state.concs,"read")

      const { Content } = Layout;
      const Moment = require('moment');
      const columns = [
          {
              title: <div style={{fontWeight:'bold', fontSize:'large' }}>Nombre</div>,
              dataIndex: 'name',
              key: 'name',
              sorter: (a, b) => a.name.localeCompare(b.name),
              sortDirections:['ascend', 'descend', 'ascend'],
              ...this.getColumnSearchProps('name','nombre'),
              responsive: ['sm'] 
            },
            {
              title: <div style={{fontWeight:'bold', fontSize:'large'}}>Email</div>,
              dataIndex: 'email',
              key: 'email',
              sorter: (a, b) => a.email.localeCompare(b.email),
              sortDirections:['ascend', 'descend', 'ascend'],
              ...this.getColumnSearchProps('email','e-mail'),
              responsive: ['sm'] 

            },
            {
              title: <div style={{fontWeight:'bold', fontSize:'large'}}>País</div>,
              dataIndex: 'countryName',
              key: 'countryName',
              width:'10%',
              sorter:(a,b) => a.countryName.localeCompare(b.countryName),
              sortDirections:['ascend', 'descend', 'ascend'],
              ...this.getColumnSearchProps('countryName','país'),
              responsive: ['sm'] 
            },
            {
              title: <div style={{fontWeight:'bold', fontSize:'large'}}>Editar</div>,
              dataIndex: 'edit',
              key: 'edit',
              width:'5%',
              render: (text,record) =>(
                          <div  style={{fontSize:'large' }}>
                          <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                          </div>
              ),
              // sorter:(a,b) => new Moment(a.date).format('YYYYMMDD') - new Moment(b.date).format('YYYYMMDD'),
              sortDirections:['ascend', 'descend', 'ascend'],
              responsive: ['sm'] 
            },


            {
              title: <div style={{fontWeight:'bold', fontSize:'large' }}>Nombre</div>,
              sorter: (a, b) => a.name.localeCompare(b.name),
              sortDirections:['ascend', 'descend', 'ascend'],
              ...this.getColumnSearchProps('name','nombre'),
              render: (record) => (
                <React.Fragment>
                  <b>{record.name}</b>
                  <br />
                  <b>País:</b>{record.countryName}
                </React.Fragment>
              ),
              responsive: ['xs'] 
            },
        ];

        const { SubMenu } = Menu;
        const reportsMenu = (
          <SubMenu disabled={this.state.isBusy}  key="reports" icon={<BarChartOutlined style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Reportes">
              <SubMenu  key="play" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de obras</h4>}>
                 <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
                   <Menu.Item>
                       <Button onClick={readPlayReport}>Ver</Button> <Button onClick={downloadPlayReport}>Descargar</Button>
                   </Menu.Item>
                 </Menu.ItemGroup>
              </SubMenu>
            <SubMenu  key="conc" title = {<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de concursantes</h4>}>
              <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>General</h4>}>
                <Menu.Item>
                  <Button onClick={readConcReport}>Ver</Button> <Button onClick={downloadConcReport}>Descargar</Button>
                </Menu.Item>
              </Menu.ItemGroup>
                  
              <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Tabla actual</h4>}>
                <Menu.Item>
                    <Button onClick={readCurrentReport}>Ver</Button> <Button onClick={downloadCurrentReport}>Descargar</Button>
                </Menu.Item>
              </Menu.ItemGroup>
            </SubMenu>
          </SubMenu>)
    return (
      <div className="page-container">
        <div className = "content-wrap">
          <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
              <AdminMenu defaultSelectedKey = {"conc"} reportMenu ={reportsMenu}/>
              <Content>
                <Table
                  loading={this.state.isBusy}
                  columns={columns}
                  bordered
                  dataSource= {this.state.concs}
                  pagination={{ position: ["bottomCenter"]}}
                  tableLayout='fixed'
                  style={{ whiteSpace: 'normal'}}
                  size="medium" 
                  onChange = {this.handleTableChange}
                />
                    {this.state.showArticle && 
                      <Modal 
                        closable = {false}
                        title={ this.state.record.title}
                        visible={this.state.showArticle} 
                        onCancel={this.hideModal}
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                            Regresar
                            </Button>,
                          ]}
                        >
                          <p><UserOutlined /> Nombre: {this.state.record.name}</p>
                          <p><MailOutlined /> Email: {this.state.record.email}</p>
                          <p><PhoneOutlined /> Teléfono: {this.state.record.phone}</p>
                          <p><GlobalOutlined /> País: {this.state.record.countryName}</p>
                          <p><EnvironmentOutlined /> Dirección: {this.state.record.address}</p>
                          <p><IdcardOutlined /> Ficha: {this.state.record.ficha}</p>
                      </Modal>
                    }
                    { this.state.edit &&
                     <Modal 
                        closable = {false}
                        title={ this.state.record.title}
                        visible={this.state.edit} 
                        onCancel={this.hideEdit}
                        footer={[
                          <Button key="save" onClick={()=>this.onClickSave()}>
                            Guardar
                          </Button>,
                          <Button key="back" onClick={this.hideEdit}>
                            Regresar
                          </Button>,
                        ]}
                      >
                        <p><UserOutlined /> Nombre:<Input className='music-input' defaultValue= {this.state.record.name} id="nameInput" /> </p>
                        <p><MailOutlined /> Email:<Input className='music-input' defaultValue= {this.state.record.email} id="emailInput" /></p>
                        <p><PhoneOutlined /> Teléfono: <Input className='music-input' defaultValue= {this.state.record.phone} id="phoneInput" /> </p>
                        <p><GlobalOutlined /> País: <Select style={{width:'80%'}} showSearch defaultValue={getCountryName(this.state.record.country)} onChange={(value)=>this.onChangeSelect(value)} >
                                  {countries["countries"].sort((a,b)=>a["name_es"].localeCompare(b["name_es"])).map((obj)=>{
                                    return <Option value={obj["name_es"]}>{obj["name_es"]}</Option>
                                })}
                                    
                                  </Select> </p>
                        <p><EnvironmentOutlined /> Dirección: <Input className='music-input' defaultValue= {this.state.record.address} id="addressInput" /></p>
                        <p><IdcardOutlined /> Ficha: <Input className='music-input' defaultValue= {this.state.record.ficha} id="fichaInput" /></p>
                      </Modal>}
                    </Content>
                  </Layout>
                </ConfigProvider>
              </div>
              <Foot admin={true}/>
          </div>
    );
  }
}
export default ConcList;


